export type SortableNotification<T> = { startTimestamp?: string } & T;

export function reverseSortTickets<T>(ns: SortableNotification<T>[]): SortableNotification<T>[] {
  const reverse = (a: SortableNotification<T>, b: SortableNotification<T>) => {
    const aTime = comparableTime(a);
    const bTime = comparableTime(b);
    return bTime - aTime;
  };

  return ns.sort(reverse);
}

export function comparableTime<T>(ticket: SortableNotification<T>): number {
  return ticket.startTimestamp ? new Date(ticket.startTimestamp).getTime() : Infinity;
}
